function exportTable(ids, tableUrl) {
    var $exportButton = $('[js=exportTable]');
    $exportButton.attr('disabled', 'disabled');
    $('.dataTables_processing', $('.dataTables_wrapper')).show();
    var table = $('.dataTable').DataTable();
    var data = table.ajax.params();
    $.ajax({
        url: Url.action(tableUrl + '/CreateTableExport'),
        type: 'POST',
        dataType: 'json',
        data: data
    })
    .done(function (request) {
        window.location = Url.action(tableUrl + '/File');
        $exportButton.removeAttr('disabled');
        $('.dataTables_processing', $('.dataTables_wrapper')).hide();
    })
    .fail(function (xhr, textStatus, errorThrown) {
        $exportButton.removeAttr('disabled');
        $('.dataTables_processing', $('.dataTables_wrapper')).hide();
    });
}